var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recipe"},[_c('h1',{staticClass:"recipe__title"},[_vm._v("Plant-based Recipes")]),_c('Listing',{attrs:{"collection":_vm.collection,"userLogged":_vm.$store.getters.userLoggedIn},on:{"addItemToCart":function($event){return _vm.$emit('addProductToCart', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }